import { useEffect } from 'react';
import { company, profile } from './data';

const baseUrl = 'https://puthasriharireddy.com';

const pageCopy = {
  home: {
    title: `${profile.name} | Founder & Product Engineer at ${company.name}`,
    description: `${profile.name}, also known as Sri Hari Reddy and P Sri Hari Reddy, is the founder of ${company.legalName}. Explore product work across AI, SaaS, web, and mobile.`,
  },
  about: {
    title: `About ${profile.name} | ${company.name}`,
    description: `Learn about ${profile.name}, founder of ${company.name}, and a product engineer working across AI, SaaS, web, mobile, interface systems, and full-stack delivery.`,
  },
  work: {
    title: `Selected Work | ${profile.name} & ${company.name}`,
    description: `Selected product work by ${profile.name}: Vyapaar Mate, BudMeet, Divine Tattoo Studio, and Aether CV across SaaS, mobile, web, and career technology.`,
  },
  company: {
    title: `${company.name} | AI, SaaS, Web & Mobile Product Delivery`,
    description: `${company.legalName} is a founder-led product engineering company for AI products, SaaS and web platforms, mobile applications, and UX modernization.`,
  },
  contact: {
    title: `Contact ${profile.name} | ${company.name}`,
    description: `Contact ${profile.name}, founder of ${company.name}, about AI, SaaS, web, mobile, product design, and product engineering engagements.`,
  },
};

function setMeta(attribute, key, content) {
  const selector = `meta[${attribute}="${key}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export function usePageSeo(page) {
  useEffect(() => {
    const copy = pageCopy[page] || pageCopy.home;
    const path = page === 'home' ? '/' : `/${page}`;
    const canonicalUrl = `${baseUrl}${path}`;
    document.title = copy.title;
    document.documentElement.lang = 'en';
    setMeta('name', 'description', copy.description);
    setMeta('property', 'og:title', copy.title);
    setMeta('property', 'og:description', copy.description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('name', 'twitter:title', copy.title);
    setMeta('name', 'twitter:description', copy.description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [page]);
}
